var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { ACTION_CUSTOM_EXPORT as actionTypes } from '../utils/constants';
import { customBulkExport } from '../services/customBulkExport';
import { getAttributeSelections, isEmptyArray } from '../utils/utils';
import { getRuleSetInfoService } from '../services/ruleSetInfo';
import { saveRuleSetInfoPerSku } from './PriceExplorerGridAction';
export var initializeState = function initializeState() {
  return {
    type: actionTypes.INITIALIZE_STATE
  };
};
export var toggleEmailSentStatus = function toggleEmailSentStatus(status) {
  return {
    type: actionTypes.TOGGLE_EMAIL_SENT_STATUS,
    payload: status
  };
};
export var onClickAttribute = function onClickAttribute(attribute) {
  return {
    type: actionTypes.ON_CLICK_ATTRIBUTE,
    payload: attribute
  };
};
export var onCheckBoxToggle = function onCheckBoxToggle(value, attribute) {
  return {
    type: actionTypes.ON_CHECKBOX_TOGGLE,
    payload: {
      value: value,
      attribute: attribute
    }
  };
};
export var showAddValueLink = function showAddValueLink(attribute) {
  return {
    type: actionTypes.SHOW_ADD_VALUE_LINK,
    payload: attribute
  };
};
export var onSubmitCustomInput = function onSubmitCustomInput(attribute) {
  return {
    type: actionTypes.ON_SUBMIT_CUSTOM_INPUT,
    payload: attribute
  };
};
export var onBlurCustomInput = function onBlurCustomInput(attribute) {
  return {
    type: actionTypes.ON_BLUR_CUSTOM_INPUT,
    payload: attribute
  };
};
export var onCustomInputChange = function onCustomInputChange(value, attribute) {
  return {
    type: actionTypes.ON_CUSTOM_INPUT_CHANGE,
    payload: {
      value: value,
      attribute: attribute
    }
  };
};
export var onSubmitCustomBulkExport = function onSubmitCustomBulkExport() {
  return function (dispatch, getState) {
    var _a = getState().customBulkExport,
        checked = _a.checked,
        sku = _a.sku,
        possibilitiesSet = _a.possibilitiesSet;
    var attributeSelections = getAttributeSelections(checked, possibilitiesSet);
    return customBulkExport(sku, attributeSelections).then(function () {
      dispatch(toggleEmailSentStatus('success'));
    }).catch(function () {
      dispatch(toggleEmailSentStatus('danger'));
    });
  };
};
export var loadPossibilitiesSetFromRuleSet = function loadPossibilitiesSetFromRuleSet(_a) {
  var sku = _a.sku,
      ruleSetInfo = _a.ruleSetInfo;
  return {
    type: actionTypes.LOAD_POSSIBILITIES_SET_FROM_RULE_SET,
    payload: {
      sku: sku,
      ruleSetInfo: ruleSetInfo
    }
  };
}; // eslint-disable-next-line consistent-return

export var loadPossibilitiesSet = function loadPossibilitiesSet() {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var skuData, ruleSetInfoPerSku, sku, ruleSetInfo;
      return __generator(this, function (_a) {
        skuData = getState().pricingGrid.skuData;
        ruleSetInfoPerSku = getState().priceExplorerGrid.ruleSetInfoPerSku;

        if (skuData) {
          sku = Object.keys(skuData)[0];
          ruleSetInfo = ruleSetInfoPerSku && ruleSetInfoPerSku[sku];
          return [2
          /*return*/
          , dispatch(loadPossibilitiesSetFromRuleSet({
            sku: sku,
            ruleSetInfo: ruleSetInfo
          }))];
        }

        return [2
        /*return*/
        ];
      });
    });
  };
};
export var setRuleSetInfo = function setRuleSetInfo() {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, skuData, logger, ruleSetInfoPerSku, promises;

      return __generator(this, function (_b) {
        _a = getState().pricingGrid, skuData = _a.skuData, logger = _a.logger;
        ruleSetInfoPerSku = {};
        promises = [];
        Object.keys(skuData).forEach(function (sku) {
          if (!ruleSetInfoPerSku[sku]) {
            promises.push(getRuleSetInfoService(sku));
          }
        });

        if (!isEmptyArray(promises)) {
          return [2
          /*return*/
          , Promise.all(promises).then(function (results) {
            if (!isEmptyArray(results)) {
              results.forEach(function (result) {
                if (result) {
                  var _a = __read(result, 2),
                      sku = _a[0],
                      ruleSetInfo = _a[1];

                  ruleSetInfoPerSku[sku] = ruleSetInfo;
                }
              });
            }

            dispatch(saveRuleSetInfoPerSku(ruleSetInfoPerSku));
          }).catch(function (error) {
            logger.logError({
              message: 'Error occurred while resolving ruleSet info',
              error: error
            }, 'RuleSet');
            dispatch(saveRuleSetInfoPerSku({}));
            throw error;
          })];
        }

        return [2
        /*return*/
        , dispatch(saveRuleSetInfoPerSku({}))];
      });
    });
  };
};